"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 10000;\n  ", "\n\n  > div {\n    animation: ", " 1s;\n    box-shadow: 0px 8px 16px 0px rgba(170, 187, 187, 0.5);\n\n    &.bounce-out {\n      animation: ", " 1.5s;\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        bottom: 50px;\n        ", "\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        bottom: 50px;\n        ", "\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        top: 50px;\n        ", "\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        top: 50px;\n        ", "\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    ", "\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var _stylitas = require("@creditas/stylitas");

var timingFunction = (0, _stylitas.css)(_templateObject());
var bounceInRight = (0, _stylitas.keyframes)(_templateObject2(), timingFunction);
var bounceOutRight = (0, _stylitas.keyframes)(_templateObject3());

var positionHelper = function positionHelper(position) {
  var sidePositions = (0, _stylitas.mediaValue)('0px', '50px');

  switch (position) {
    case 'top-right':
      return (0, _stylitas.css)(_templateObject4(), (0, _stylitas.mq)({
        right: sidePositions
      }));

    case 'top-left':
      return (0, _stylitas.css)(_templateObject5(), (0, _stylitas.mq)({
        left: sidePositions
      }));

    case 'bottom-left':
      return (0, _stylitas.css)(_templateObject6(), (0, _stylitas.mq)({
        left: sidePositions
      }));

    case 'bottom-right':
    default:
      return (0, _stylitas.css)(_templateObject7(), (0, _stylitas.mq)({
        right: sidePositions
      }));
  }
};

var container = function container(_ref) {
  var position = _ref.position;
  return (0, _stylitas.css)(_templateObject8(), positionHelper(position), bounceInRight, bounceOutRight);
};

exports.container = container;